import { UserRole } from "types/BETypes";

import { ExtendedUserProfileResponseDto, UserProfileResponseDto } from "utils/swagger_react_query";

export const pageOpenedAnalytics = (userData?: UserProfileResponseDto | null | undefined) => {
  const userDataPayload: Pick<
    ExtendedUserProfileResponseDto,
    "userId" | "firstName" | "lastName" | "companyId" | "lastActiveRole"
  > = {
    userId: userData?.activeCompanyUser?.userId || "",
    firstName: userData?.personalInfo?.firstName || "",
    lastName: userData?.personalInfo?.lastName || "",
    companyId: userData?.activeCompanyUser?.companyId || "",
    lastActiveRole: userData?.activeCompanyUser?.lastActiveRole as UserRole,
  };
  const payload: Record<string, unknown>[] = [];
  if (userData?.activeCompanyUser) {
    payload.push(
      { userData: userDataPayload },
      {
        userId: userData?.activeCompanyUser?.userId || "",
      },
    );
  }

  const analytics = (window as any).analytics;
  analytics?.page(...payload);
};
